/* =========================================================
   MOODÈRA — Shared behavior script
   Tüm etkileşimli moodera-* section'ları bu dosyayı kullanır.
   Sayfa ilk yüklendiğinde VE Shopify tema editöründe bir
   section yeniden render edildiğinde (shopify:section:load)
   otomatik olarak yeniden kurulur.
   ========================================================= */
(function () {
  "use strict";

  var prefersReducedMotion =
    window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- Scroll reveal ---------- */
  function initReveal(root) {
    var els = root.querySelectorAll("[data-moodera-reveal]:not([data-moodera-revealed])");
    if (!els.length) return;

    if (prefersReducedMotion) {
      els.forEach(function (el) {
        el.classList.add("is-visible");
        el.setAttribute("data-moodera-revealed", "1");
      });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: "0px 0px -6% 0px" }
    );

    els.forEach(function (el) {
      el.setAttribute("data-moodera-revealed", "1");
      io.observe(el);
    });
  }

  /* ---------- Hero slider ---------- */
  function initHero(section) {
    if (section.dataset.mooderaHeroInit) return;
    section.dataset.mooderaHeroInit = "1";

    var frames = section.querySelectorAll("[data-hero-frame]");
    var texts = section.querySelectorAll("[data-hero-text]");
    var dots = section.querySelectorAll("[data-hero-dot]");
    var prevBtn = section.querySelector("[data-hero-prev]");
    var nextBtn = section.querySelector("[data-hero-next]");
    if (!frames.length) return;

    var autoplay = section.dataset.autoplay === "true" && !prefersReducedMotion;
    var interval = parseInt(section.dataset.interval, 10) || 7000;
    var timer = null;
    var current = 0;

    function goTo(index) {
      current = (index + frames.length) % frames.length;
      frames.forEach(function (f, i) { f.classList.toggle("is-active", i === current); });
      texts.forEach(function (t, i) { t.classList.toggle("is-active", i === current); });
      dots.forEach(function (d, i) { d.classList.toggle("is-active", i === current); });
    }

    function stopAutoplay() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    function startAutoplay() {
      if (!autoplay) return;
      stopAutoplay();
      timer = setInterval(function () { goTo(current + 1); }, interval);
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener("click", function () {
        stopAutoplay();
        goTo(i);
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener("click", function () { stopAutoplay(); goTo(current - 1); });
    }
    if (nextBtn) {
      nextBtn.addEventListener("click", function () { stopAutoplay(); goTo(current + 1); });
    }

    // Klavye ok tuşları — sadece hero görünür alandayken tepki versin
    document.addEventListener("keydown", function (e) {
      if (e.key !== "ArrowLeft" && e.key !== "ArrowRight") return;
      var rect = section.getBoundingClientRect();
      var inView = rect.top < window.innerHeight * 0.75 && rect.bottom > window.innerHeight * 0.25;
      if (!inView) return;
      stopAutoplay();
      goTo(current + (e.key === "ArrowRight" ? 1 : -1));
    });

    startAutoplay();
  }

  /* ---------- Featured slider ("Three to begin with") ---------- */
  function initFeatured(section) {
    if (section.dataset.mooderaFeaturedInit) return;
    section.dataset.mooderaFeaturedInit = "1";

    var track = section.querySelector("[data-featured-track]");
    var slides = section.querySelectorAll(".moodera-featured__slide");
    var prevBtn = section.querySelector("[data-featured-prev]");
    var nextBtn = section.querySelector("[data-featured-next]");
    var counter = section.querySelector("[data-featured-counter]");
    var nameEl = section.querySelector("[data-featured-name]");
    var dots = section.querySelectorAll("[data-featured-dot]");
    if (!track || !slides.length) return;

    var current = 0;
    var total = slides.length;

    function pad(n) { return n < 10 ? "0" + n : "" + n; }

    function render() {
      track.style.transform = "translateX(-" + current * 100 + "%)";
      if (counter) counter.textContent = pad(current + 1) + " / " + pad(total);
      dots.forEach(function (d, i) { d.classList.toggle("is-active", i === current); });
      if (nameEl) {
        var titleEl = slides[current].querySelector(".moodera-featured__title");
        nameEl.textContent = titleEl ? titleEl.textContent.toUpperCase() : "";
      }
    }

    function goTo(index) {
      current = (index + total) % total;
      render();
    }

    if (prevBtn) prevBtn.addEventListener("click", function () { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener("click", function () { goTo(current + 1); });
    dots.forEach(function (dot, i) { dot.addEventListener("click", function () { goTo(i); }); });

    render();
  }

  /* ---------- Collection grid filter ---------- */
  function initCollectionFilter(section) {
    if (section.dataset.mooderaCollectionInit) return;
    section.dataset.mooderaCollectionInit = "1";

    var buttons = section.querySelectorAll("[data-moodera-filter]");
    var cards = section.querySelectorAll("[data-moodera-card]");
    if (!buttons.length) return;

    buttons.forEach(function (btn) {
      btn.addEventListener("click", function () {
        var family = btn.getAttribute("data-moodera-filter");
        buttons.forEach(function (b) { b.classList.toggle("is-active", b === btn); });
        cards.forEach(function (card) {
          var match = family === "ALL" || card.getAttribute("data-moodera-card-family") === family;
          card.classList.toggle("moodera-card--hidden", !match);
        });
      });
    });
  }

  /* ---------- Scent stories tabs ---------- */
  function initStories(section) {
    if (section.dataset.mooderaStoriesInit) return;
    section.dataset.mooderaStoriesInit = "1";

    var tabs = section.querySelectorAll("[data-story-tab]");
    var panels = section.querySelectorAll("[data-story-panel]");
    if (!tabs.length) return;

    tabs.forEach(function (tab, i) {
      tab.addEventListener("click", function () {
        tabs.forEach(function (t, j) { t.classList.toggle("is-active", j === i); });
        panels.forEach(function (p, j) { p.classList.toggle("is-active", j === i); });
      });
    });
  }

  /* ---------- Gifting note toggle ---------- */
  function initGifting(section) {
    if (section.dataset.mooderaGiftingInit) return;
    section.dataset.mooderaGiftingInit = "1";

    var toggleBtn = section.querySelector("[data-moodera-note-toggle]");
    var note = section.querySelector("[data-moodera-note]");
    var textarea = section.querySelector("[data-moodera-note-input]");
    var count = section.querySelector("[data-moodera-note-count]");
    if (!toggleBtn || !note) return;

    toggleBtn.addEventListener("click", function () {
      var isOpen = note.classList.toggle("is-open");
      toggleBtn.textContent = isOpen ? "Hide card" : "Add a note";
    });

    if (textarea && count) {
      textarea.addEventListener("input", function () {
        count.textContent = textarea.value.length + " / 140";
      });
    }
  }

  /* ---------- FAQ accordion ---------- */
  function initFaq(section) {
    if (section.dataset.mooderaFaqInit) return;
    section.dataset.mooderaFaqInit = "1";

    var items = section.querySelectorAll("[data-faq-item]");
    items.forEach(function (item) {
      var q = item.querySelector("[data-faq-q]");
      var a = item.querySelector("[data-faq-a]");
      if (!q || !a) return;

      q.addEventListener("click", function () {
        var isOpen = item.classList.contains("is-open");
        item.classList.toggle("is-open", !isOpen);
        q.setAttribute("aria-expanded", String(!isOpen));
        a.style.maxHeight = !isOpen ? a.scrollHeight + "px" : "0px";
      });
    });
  }

  /* ---------- Master init ---------- */
  function initAll(root) {
    root = root || document;
    initReveal(root);
    root.querySelectorAll("[data-moodera-hero]").forEach(initHero);
    root.querySelectorAll("[data-moodera-featured]").forEach(initFeatured);
    root.querySelectorAll("[data-moodera-collection]").forEach(initCollectionFilter);
    root.querySelectorAll("[data-moodera-stories]").forEach(initStories);
    root.querySelectorAll(".moodera-gifting").forEach(initGifting);
    root.querySelectorAll("[data-moodera-faq]").forEach(initFaq);
  }

  document.addEventListener("DOMContentLoaded", function () { initAll(document); });

  // Tema editöründe bir section eklendiğinde/güncellendiğinde yeniden kur
  document.addEventListener("shopify:section:load", function (e) { initAll(e.target); });

  // Sürekli scroll-reveal kontrolü (yeni eklenen section'lar için)
  document.addEventListener("shopify:section:select", function (e) { initAll(e.target); });
})();
